<template>
  <div class="content-panel">
    <div class="panel-title-wrap">
      <h3 class="panel-title">个人信息</h3>
      <span class="panel-sub">管理您的基本资料</span>
    </div>
    <div class="profile-form">
      <div class="form-row avatar-row">
        <label class="form-label">头像</label>
        <div class="avatar-upload">
          <div class="avatar-preview">
            <img
              v-if="form.avatar"
              :src="form.avatar + '?r=' + r"
              class="avatar-img"
              alt="头像"
            />
            <span v-else class="avatar-text-lg">{{ avatarText }}</span>
          </div>
          <button class="btn-upload" @click="handleUploadAvatar">
            更换头像
          </button>
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            class="file-input"
            @change="handleFileChange"
          />
        </div>
      </div>
      <div class="form-row">
        <label class="form-label">昵称</label>
        <div class="form-control-wrap">
          <input type="text" v-model="form.nickname" class="form-input" />
        </div>
      </div>
      <div class="form-row">
        <label class="form-label">电话</label>
        <div class="form-control-wrap">
          <input type="text" v-model="form.phone" class="form-input" />
        </div>
      </div>
      <div class="form-row">
        <label class="form-label">地址</label>
        <div class="form-control-wrap">
          <input type="text" v-model="form.address" class="form-input" />
        </div>
      </div>
      <div class="form-actions">
        <button
          class="btn-submit"
          :disabled="saving"
          @click="handleSaveProfile"
        >
          {{ saving ? "保存中..." : "保存信息" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfilePanel",
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {},
      saving: false,
      // 标记是否上传了新头像
      avatarChanged: false,
      r: new Date().getTime(),
    };
  },

  computed: {
    avatarText() {
      const first = this.form.first_name || "";
      const last = this.form.last_name || "";
      return (first.charAt(0) + last.charAt(0)).toUpperCase() || "TH";
    },
  },
  watch: {
    profile: {
      handler(val) {
        this.form = { ...val };
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 点击更换头像，触发隐藏的文件选择框
    handleUploadAvatar() {
      this.$refs.fileInput.click();
    },
    // 选择文件后上传
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 校验文件类型
      if (!file.type.startsWith("image/")) {
        this.$message.error("请选择图片文件");
        return;
      }

      // 校验文件大小（限制 5MB）
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error("图片大小不能超过 5MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      this.$api.file
        .upload(formData)
        .then((res) => {
          if (res.code === 1) {
            this.$message.error(res.msg || "上传失败");
            return;
          }
          // 上传成功，返回 data.path，显示到对应位置
          const path = res.data && res.data.path;
          if (path) {
            this.form.avatar = path;
            // 标记已上传新头像
            this.avatarChanged = true;
            this.$message.success("头像上传成功");
          } else {
            this.$message.error("上传失败，未获取到图片地址");
          }
        })
        .catch(() => {
          this.$message.error("上传失败，请稍后重试");
        })
        .finally(() => {
          // 重置文件输入框，以便再次选择同一文件
          event.target.value = "";
        });
    },
    // 保存个人信息（只提交修改的字段）
    handleSaveProfile() {
      if (this.saving) return;
      this.saving = true;

      const params = {
        // 未上传新头像则传空，有修改才传图片路径
        avatar: this.avatarChanged ? this.form.avatar : "",
        nickname: this.form.nickname,
        // email: this.form.email,
        phone: this.form.phone,
        address: this.form.address,
      };

      this.$api.user
        .update(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.error(res.msg || "保存失败");
            return;
          }
          this.$message.success("保存成功");
          this.$emit("save", params);
        })
        .catch(() => {
          this.$message.error("保存失败，请稍后重试");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.content-panel {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.panel-title-wrap {
  margin-bottom: 28px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 4px 0;
}

.panel-sub {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.35);
}

/* ===== 表单行 ===== */
.form-row {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.form-label {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}

.form-control-wrap {
  flex: 1;
  display: flex;
  gap: 12px;
  align-items: center;
}

.form-input {
  flex: 1;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
  max-width: 400px;
}

.form-input::placeholder {
  color: rgba(255, 255, 255, 0.25);
}

.form-input:focus {
  border-color: rgba(0, 180, 255, 0.4);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 3px rgba(0, 180, 255, 0.05);
}

/* ===== 头像上传 ===== */
.avatar-row {
  padding: 16px 0;
}

.avatar-upload {
  display: flex;
  align-items: center;
  gap: 16px;
}

.avatar-preview {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00b4ff, #7c3aed);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar-text-lg {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.btn-upload {
  padding: 8px 20px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-upload:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.file-input {
  display: none;
}

/* ===== 底部提交按钮 ===== */
.form-actions {
  padding-top: 24px;
  display: flex;
  justify-content: flex-start;
}

.btn-submit {
  padding: 12px 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 100, 255, 0.3);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 16px 0;
  }
  .form-label {
    width: 100%;
  }
  .form-control-wrap {
    width: 100%;
    flex-wrap: wrap;
  }
  .form-input {
    max-width: 100%;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .panel-title {
    font-size: 17px;
  }
  .form-actions {
    width: 100%;
  }
  .btn-submit {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
}
</style>
